import { filtersHelper } from '@/utils';
import { locationModel } from '@/models/api/location.model';

export const phoneExt = (data) => ({
    uuid: data.uuid,
    name: data.name,
    date: data.date,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    location: data.location ? locationModel(data.location) : null,
});